const baseURL = process.env.REACT_APP_BACKEND_URL;

export default baseURL;

export const endPoints = {
    //auth
    login: 'api/Admin/Login',

    //refresh token
    refreshToken: 'api/Admin/Login/refresh',

    //Permissions
    getallPermissions: 'api/Admin/Permission',

    //Merchant Payment Status
    updatePaymentStatus: 'api/Admin/Merchant/UpdatePaymentStatus',

    //Merchant Reports
    getMerchantReports: 'api/Admin/Reports/GetAllTransactions',

    //Dropdowns
    getDropdownUsers: 'api/Dropdown/users',
    getDropdownRoles: 'api/Dropdown/roles',
    getDropdownTicketsTypes: 'api/Dropdown/ticketTypes',
    getDropdownTicketsStatus: 'api/Dropdown/ticketStatues',
    getDropdownPermissions: 'api/Dropdown/GetPermissions',
    getDropdownPaymentMethod: 'api/Dropdown/paymentMethods',

    //users
    getallUsers: 'api/Admin/User',
    addUser: 'api/Admin/User',
    updateUser: 'api/Admin/User',
    getUserById: (id) => `api/Admin/User/${id}`,
    deleteUser: (id) => `api/Admin/User/${id}`,

    //forget password
    verifyEmail: 'api/Admin/Login/VerifyUser',
    verifyOtp: 'api/Admin/Login/VerifyUserOTP',

    //update password
    changePassword: 'api/Admin/User',

    //roles
    getallRoles: 'api/Admin/Role',
    addRole: 'api/Admin/Role',
    updateRole: 'api/Admin/Role',
    getRoleById: (id) => `api/Admin/Role/${id}`,
    deleteRole: (id) => `api/Admin/Role/${id}`,

    //Invoices
    getallInvoice: 'api/Admin/invoice',
    addInvoice: 'api/Admin/invoice',
    updateInvoice: 'api/Admin/invoice',
    getInvoiceById: (id) => `api/Admin/invoice/${id}`,
    deleteInvoice: 'api/Admin/invoice/delete',

    //Merchants
    getallMerchants: 'api/Admin/Merchant',
    addMerchant: 'api/Admin/Merchant',
    blackListMerchant: 'api/Admin/Merchant/BlackListMerchant',
    updateMerchant: 'api/Admin/Merchant',
    merchantApproval: 'api/Admin/Merchant',
    merchantPaymentStatus: 'api/Admin/Merchant',
    getMerchantById: (id) => `api/Admin/Merchant/${id}`,
    deleteMerchant: (id) => `api/Admin/Merchant/${id}`,

    //GateWays
    getallPaymentGateways: 'api/Admin/Gateway',
    addPaymentGateway: 'api/Admin/Gateway',
    updatePaymentGateway: 'api/Admin/Gateway',
    getPaymentGatewayById: (id) => `api/Admin/Gateway/${id}`,
    deletePaymentGateway: 'api/Admin/Gateway',

    // Tickets Api
    getAllTicket: 'api/Ticket/getAll',
    getTicketById: (id) => `api/Ticket/${id}`,
    createTicketThread: 'api/Ticket/AddTicketThread',

    //Merchants Module Management
    getAllMerchantModule: 'api/Admin/MerchantModule',
    getMerchantModuleById: (id) => `api/Admin/MerchantModule/${id}`,
    createMerchantModule: 'api/Admin/MerchantModule',
    updateMerchantModule: 'api/Admin/MerchantModule',

    //Admin Module Management
    getAllAdminModule: 'api/Admin/Module',
    getAdminModuleById: (id) => `api/Admin/Module/${id}`,
    createAdminModule: 'api/Admin/Module',
    updateAdminModule: 'api/Admin/Module'
};
